import _extends from "@babel/runtime/helpers/extends";
import { Box } from '@wix/design-system';
import { DomainSearchSuiteModule } from '@wix/domains-search-suite';
import React from 'react';
import { useIsMobile } from '../../hooks/useIsMobile';
export const RecommendationsError = _ref => {
  let {
    error,
    onRetry,
    type = 'default',
    ...props
  } = _ref;
  const isMobile = useIsMobile();
  if (!error) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Box, _extends({
    flex: 1,
    direction: "vertical",
    padding: isMobile ? '0 SP4' : '0 48px',
    align: "center",
    verticalAlign: isMobile ? 'middle' : undefined,
    textAlign: isMobile ? 'center' : undefined
  }, props), error === 'NetworkIssue' ? /*#__PURE__*/React.createElement(DomainSearchSuiteModule.SDK.Components.NetworkIssue, {
    onRetry: onRetry
  }) : error === 'RateLimited' ? /*#__PURE__*/React.createElement(DomainSearchSuiteModule.SDK.Components.RateLimit, {
    onRetry: onRetry
  }) : error === 'TechnicalIssue' ? /*#__PURE__*/React.createElement(DomainSearchSuiteModule.SDK.Components.TechnicalIssue, {
    onRetry: onRetry
  }) : /*#__PURE__*/React.createElement(DomainSearchSuiteModule.SDK.Components.NoRecommendations, {
    type: type
  }));
};
//# sourceMappingURL=RecommendationsError.js.map